var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editor",attrs:{"id":_vm.id}},[_c('textarea',{ref:"textarea",attrs:{"name":_vm.name},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }